import React from 'react'
import styled from 'styled-components'
import { Brands } from '../assets/icons'
import { brandIcons } from '../config'

const SectionWrapper = styled.section`
  overflow: hidden;
  width: 100%;
  margin-top: 40px;
`
const ClientContainer = styled.div`
  display: flex;
  flex-direction: row;
  .first-column {
    display: flex;
    flex-direction: row;
    width: 3784px;
    animation: firstAnimation 40s linear infinite;
  }
  .second-column {
    display: flex;
    flex-direction: row;
    width: 3784px;
    animation: firstAnimation 40s linear infinite;
  }
  @keyframes firstAnimation {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`

const HomeClients = () => {
  return (
    <SectionWrapper>
      <ClientContainer>
        <div className="first-column">
          {brandIcons &&
            brandIcons.map(({ name }, i) => (
              <div className="card" key={i}>
                <Brands name={name} />
              </div>
            ))}
        </div>
        <div className="second-column">
          {brandIcons &&
            brandIcons.map(({ name }, i) => (
              <div className="card" key={i}>
                <Brands name={name} />
              </div>
            ))}
        </div>
      </ClientContainer>
    </SectionWrapper>
  )
}

export default HomeClients
